import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WishlistComponent } from './components/wishlist/wishlist.component';
import { HomeComponent } from './components/home/home.component';
import { TestComponent } from './components/test/test.component';
import { ShopComponent } from './components/shop/shop.component';
import { SingleproductComponent } from './components/singleproduct/singleproduct.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { MarqueComponent } from './components/marque/marque.component';
import { ContactComponent } from './components/contact/contact.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { AccountComponent } from './components/account/account.component';
import { AccountordersComponent } from './components/accountorders/accountorders.component';
import { AccountdetailsComponent } from './components/accountdetails/accountdetails.component';
import { AccountinfosComponent } from './components/accountinfos/accountinfos.component';
import { SubcategorieComponent } from './components/subcategorie/subcategorie.component';

const routes: Routes = [
{ path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    pathMatch: 'full',
    component: HomeComponent
},

  { path: 'shop/:id/:libelle', component: ShopComponent },
  { path: 'shop/:id/:libelle/:subId/:subLibelle', component: ShopComponent },

  { path: 'subcategorie/:subId/:subLibelle', component: SubcategorieComponent },
  { path: 'singleproduct/:libelle/:id', component: SingleproductComponent },

  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },

  { path: 'account', component: AccountComponent },
  { path: 'accountorders', component: AccountordersComponent },
  { path: 'accountinfos', component: AccountinfosComponent },
  { path: 'accountordersdetails/:id', component: AccountdetailsComponent },

  { path: 'test', component: TestComponent },
  { path: 'cart', component: CartComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'checkout', component: CheckoutComponent },

  { path: 'marque/:marId/:marLibelle', component: MarqueComponent },
  { path: 'wishlist', component: WishlistComponent },

  // fallback route for 404
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
